<template lang="pug">
  v-stepper.pb-2.my-2(v-model="formConfig.stepVisible" vertical)

    v-stepper-step.pl-2.pl-sm-6(:complete="formConfig.stepVisible > 1" step="1", :editable="formConfig.step1.editable") {{ translations.steps.step2 }}
    v-stepper-content.ml-5.ml-sm-9(step="1")
      ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
        v-form(@submit.prevent="handleSubmit(onSubmitStep1)")
          v-container.px-0.px-sm-4.py-0(fluid)
            v-row
              v-col(cols="12")
                BaseTextField(rules="required" v-model="form.name", :label="translations.label.name")
              v-col(cols="12")
                BaseTextField(rules="required|numeric|min_value:0|max_value:100" v-model="form.fee", :label="translations.label.fee")
              v-col(cols="12")
                ValidationProvider(rules="required" v-slot="{ errors }")
                  v-select(:items="operatorsList" item-text="text" item-value="value" return-object v-model="form.organizer", :error="errors.length > 0")
                    template(v-slot:label)
                      v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                      | {{ translations.label.organizer }}
                  span.red--text.text--accent-2(v-if="errors.length > 0")
                    v-icon(color="red accent-2") mdi-alert
                    |  {{ errors[0] }}
                p {{ translations.label.jurisdiction }}: {{ getJurisdiction(form.organizer)}}
              v-col(cols="12")
                ValidationProvider(rules="required" v-slot="{ errors }")
                  v-select(:items="membersListAll" chips multiple item-text="text" item-value="value" return-object v-model="form.members", :error="errors.length > 0")
                    template(v-slot:label)
                      v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                      | {{ translations.label.members }}
                  span.red--text.text--accent-2(v-if="errors.length > 0")
                    v-icon(color="red accent-2") mdi-alert
                    |  {{ errors[0] }}
              v-col.text-right(cols="12")
                v-btn(:disabled="invalid"
                  color="primary"
                  type="submit"
                  :loading="loadingCreate") {{ translations.buttons.next }}
    v-stepper-step.pl-2.pl-sm-6(:complete="formConfig.stepVisible > 2" step="2", :editable="formConfig.step2.editable") {{ translations.steps.step3 }}
    v-stepper-content.ml-5.ml-sm-9(step="2")
      v-container.px-0.px-sm-4.py-0(fluid)
        v-row
          v-col(cols="12" sm="8")
            BaseDefinitionList(:items="getResumeDetails()" keysAlign="text-left")
          v-col(cols="12")
            v-btn.float-right.big(
              color="primary"
              type="submit"
              @click="submitDataForm"
              ) {{ translations.buttons.create }}

</template>

<script>

  export default {
    name: "NetworkCreate",
    props: {
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      operatorsList: {
        type: Array,
        default: function(){
          return []
        }
      },
      jurisdictions: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      formConfig: {
        stepVisible: 1,
        step1: {
          editable: true,
        },
        step2:{
          editable: false,
        },
        step3:{
          editable: false,
        },
      },
      form: {
        name: '',
        organizer: '',
        members: [],
        fee: '0',
        jurisdiction: null,
      },
    }),
    computed: {
      loadingCreate() {
        return this.$store.state.statusCode.createNetwork.loading;
      },
      stateCreate() {
        return this.$store.state.statusCode.createNetwork.state;
      },
      membersListAll() {
        const vm = this;
        return this.operatorsList.filter(operator => {
          return operator.value != vm.form.organizer.value 
        });
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.clearFields();
          this.$refs.validator.reset();
        }
      },
      stateCreate: function(val){
        if (val == 200) {
          this.$emit('successCreate');
        }
      },
    },
    created(){
      this.clearFields();
    },
    methods:{
      onSubmitStep1(){
        this.formConfig.stepVisible = 2;
        this.formConfig.step2.editable = true;
      },
      submitDataForm(){
        let formSend = {
          data: {
            name: this.form.name,
            organizer: this.form.organizer.value,
            members: this.form.members.map((item)=>{ return item.value; }),
            fee: parseInt(this.form.fee),
            jurisdiction: this.form.organizer.jurisdiction,
          }
        };
        formSend.data.members.push(this.form.organizer.value)
        this.$store.dispatch('createNetwork', formSend);
      },
      clearFields(){
        this.form.name = '';
        this.form.organizer = '';
        this.form.members = [];
        this.form.fee = '0';
        this.form.jurisdiction = null;
        this.formConfig.stepVisible = 1;
        this.formConfig.step2.editable = false;
        this.formConfig.step3.editable = false;
      },
      getJurisdiction(organizer){
        if(organizer != undefined && organizer.jurisdiction != undefined){
          return this.jurisdictions.find((item)=>{
            return item.value == organizer.jurisdiction
          }).text
        } else {
          return ''
        }
      },
      getResumeDetails(){
        let fields = [
          {
            key: this.translations.label.name,
            value: this.form.name
          },
          {
            key: this.translations.label.organizer,
            value: this.form.organizer.text
          },
          {
            key: this.translations.label.jurisdiction,
            value: this.getJurisdiction(this.form.organizer)
          },
          {
            key: this.translations.label.members,
            value: this.form.members.map((item)=>{ return item.text })
          },
          {
            key: this.translations.label.fee,
            value: this.form.fee
          },
        ];
        return fields;
      },
    }
  }
</script>

<style lang="sass">
</style>